<template>
  <nav id="UiLayer">
      <Logo></Logo>
      <BackButton v-if="!contentComponentOpen && !onHomePage"></BackButton>
      <FullscreenButton v-if="!contentComponentOpen" :onHomePage="onHomePage"></FullscreenButton>
      <HotspotLabelsButton v-if="!contentComponentOpen" :onHomePage="onHomePage"></HotspotLabelsButton>
      <CustomNavigation v-if="hasCustomNavigation && !contentComponentOpen" :onHomePage="onHomePage"></CustomNavigation>
      <BurgerNavigation :onHomePage="onHomePage"></BurgerNavigation>
      <transition name="fadeUI">
        <img class="UiLayer__gradient" v-if="!onHomePage && !contentComponentOpen" src="@/assets/img/ui/gradient.png">
      </transition>
  </nav>
</template>
<script>
import Logo from "../ui/Logo.vue";
import Breadcrumbs from "../ui/Breadcrumbs.vue";
import BackButton from '../ui/BackButton.vue';
import FullscreenButton from '../ui/FullscreenButton.vue';
import HotspotLabelsButton from '../ui/HotspotLabelsButton.vue';
import CustomNavigation from '../ui/CustomNavigation.vue';
import BurgerNavigation from '../ui/BurgerNavigation.vue';

export default {
  components: {
    // Ui Components
    Logo,
    Breadcrumbs,
    BackButton,
    FullscreenButton,
    HotspotLabelsButton,
    CustomNavigation,
    BurgerNavigation
  },
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {
    onHomePage() {
      this.$route;
      return app.api.PageManager.onHomePage();
    },
    hasCustomNavigation() {
      this.$route;
      let shownav = false;
      let laproomids = app.api.PageManager.getCustomComponentFromType("customNavigation").data.showNavigation.map(id => {
        return app.api.PageManager.getRouteFromID(id.scene)
      })

      laproomids.forEach(route => {
        if(app.api.PageManager.getCurrentRoute().endsWith(route))
         shownav = true
      })
      
      return shownav; 
    },
    contentComponentOpen() {
      return this.$store.getters.getContentComponentOpen;
    }
  }
};
</script>

<style lang="scss">
#UiLayer {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;

  & > button, .uibutton {
    position: absolute;
    height: 45px;
    width: 45px;
    bottom: 40px;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 1000px;
    transition: background-image 0.2s var(--tk-easeinout);
    box-shadow: var(--shadow-medium);
  }

  * {
    pointer-events: all;
  }

  .UiLayer__gradient {
    position: absolute;
    left: 0;
    top: 32px;
    width: 100%;
    z-index: -1;
    pointer-events: none;
  }
}

.fadeUI-enter-active, .fadeUI-leave-active {
  transition-property: opacity;
  transition-duration: 0.4s;
  transition-timing-function: ease;
}

.fadeUI-enter-from {
  opacity: 0;
}

.fadeUI-leave-to {
  opacity: 0;
}
</style>